import { useAbility } from "@casl/react";

import { AbilityContext } from ".";

export function useAppAbility() {
  return useAbility(AbilityContext);
}
